import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const SeIndexSnapshot = React.lazy(() =>
    import('../SeIndexSnapshot')
);
const seIndexSnapshotRoutesRegistry = [
    {
        path: PAGE_URL.SE_INDEX_SNAPSHOT_PAGE,
        element: <SeIndexSnapshot />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default seIndexSnapshotRoutesRegistry;
